<div class="row">
    <div class="col-xl-3 col-md-6">
        <div class="mb-5 card card-box card-box-border-bottom border-success">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-1">
                        <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success"></fa-icon>
                    </div>
                    <div class="mt-3 line-height-sm">
                        <b class="font-size-lg pr-1">2,345</b>
                        <span class="text-black-50">users</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="mb-5 card card-box card-box-border-bottom border-danger">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-1">
                        <fa-icon [icon]="['far', 'keyboard']" class="font-size-xxl text-danger"></fa-icon>
                    </div>
                    <div class="mt-3 line-height-sm">
                        <b class="font-size-lg pr-1">3,568</b>
                        <span class="text-black-50">clicks</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="mb-5 card card-box card-box-border-bottom border-warning">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-1">
                        <fa-icon [icon]="['far', 'chart-bar']" class="font-size-xxl text-warning"></fa-icon>
                    </div>
                    <div class="mt-3 line-height-sm">
                        <b class="font-size-lg pr-1">$9,693</b>
                        <span class="text-black-50">revenue</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="mb-5 card card-box card-box-border-bottom border-info">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-1">
                        <fa-icon [icon]="['far', 'building']" class="font-size-xxl text-info"></fa-icon>
                    </div>
                    <div class="mt-3 line-height-sm">
                        <b class="font-size-lg pr-1">431</b>
                        <span class="text-black-50">sales</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>